export default (field) => {
  return field.endsWith('_in') || field.endsWith('_any') || field.startsWith('field:');
}
